import feather from 'feather-icons';
import findPosts from '../components/postsFilter';

(function ($) {
	$(document).ready(function ($) {
		let wrapperElement = $('.blog__content__wrapper');
		let wrapperSelects = $('.blog__banner__selects__wrapper');
		let categoriesSelect = $('#categories-select');
		let observer = document.getElementById('observer-blog');

		let requestData = {
			postType: 'post',
			taxonomy: 'category',
			currentPage: 1,
			postsPerPage: 4
		};

		wrapperSelects.change(function () {
			requestData.category = categoriesSelect.val();
			requestData.currentPage = 1;

			if (observer) {
				intersectionObserver.unobserve(observer);
			}

			findPosts(requestData, responseBlog, 'overwrite', wrapperElement);
		});
		const intersectionObserver = new IntersectionObserver(
			(entries) => {
				console.log(entries[0].isIntersecting);
				if (entries[0].isIntersecting) {
					requestData.currentPage++;
					if (observer) {
						intersectionObserver.unobserve(observer);
					}

					findPosts(requestData, responseBlog, 'append', wrapperElement);
				}
			},
			{
				rootMargin: '0px'
			}
		);

		if (observer) {
			intersectionObserver.observe(observer);
		}

		function responseBlog(res) {
			// $('.posts-filter__loading-message').remove();

			if (res.length) {
				let html = '';

				res.forEach((element) => {
					html += renderBlog(element);
				});

				if (requestData.currentPage === 1) {
					wrapperElement.html(html);
					intersectionObserver.observe(observer);
				} else {
					wrapperElement.append(html);

					if (observer) {
						intersectionObserver.observe(observer);
					}
				}

				feather.replace();
			} else {
				intersectionObserver.unobserve(observer);
			}

			$('.posts-filter__loading-message').remove();
		}

		function renderBlog(element) {
			let html = `
				<a href="${element.permalink}" class="blog__content__wrapper__item">
					<div class="blog__content__thumb">
					${element.thumbnail}
					</div>
					<div class="blog_content_containers">
            			<i data-feather="chevron-down"></i>
						 <h3>${element.title} </h3>
						<p>${element.descripcion_blog}</p>
				   </div>
				</a>
			`;
			return html;
		}
	});
})(jQuery);
